import PropTypes from 'prop-types';
import React from 'react';

import componentStyles from './FeeDisclaimer.module.less';

const FeeDisclaimer = (props) => {
  const { style, text } = props;

  return <span className={style} data-testid="fee-disclaimer" >{text}</span>;
};

FeeDisclaimer.propTypes = {
  style: PropTypes.string,
  text: PropTypes.string.isRequired,
};

FeeDisclaimer.defaultProps = {
  style: componentStyles['fee-disclaimer'],
};

export default FeeDisclaimer;
